import { render, staticRenderFns } from "./WaitSmsOtp.vue?vue&type=template&id=68555256&"
import script from "./WaitSmsOtp.vue?vue&type=script&lang=ts&"
export * from "./WaitSmsOtp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports